// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/TransactionDetailsModal/TransactionDetailsModal.css */

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(34, 42, 63, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease;
  }
  
  .modal-content {
    background: #FFFFFF;
    border-radius: 16px;
    padding: 32px;
    width: 100%;
    max-width: 550px;
    position: relative;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    animation: slideUp 0.4s ease;
    font-family: 'Inter', sans-serif;
  }
  
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  
  .modal-close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    background: #EBF4FF;  
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    font-size: 20px;
    font-weight: bold;
    line-height: 36px;
    text-align: center;
    color: #0047AB;  
    cursor: pointer;
    transition: transform 0.2s;
  }
  .modal-close-btn:hover {
    transform: scale(1.1);
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
  .modal-title p {
    font-size: 14px;
    font-weight: 500;
    color: #0047AB; 
    margin: 0 0 4px;
    text-transform: uppercase;
  }
  .modal-title h1 {
    font-size: 36px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    line-height: 1.2;
  }
  .modal-title span {
    font-size: 14px;
    color: #9CA3AF;  
  }
  .modal-status-icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 12px;  
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal-status-icon-wrapper img {
    width: 24px;
    height: 24px;
  }
  
  
  .modal-status-icon-wrapper.successful { background-color: #DEF7EC; }
  .modal-status-icon-wrapper.pending { background-color: #FEF3C7; }
  .modal-status-icon-wrapper.failed { background-color: #FEE2E2; }
  
  .modal-details {
    display: flex;
    flex-direction: column;
    gap: 24px;  
  }
  
  .detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    border-bottom: 1px solid #F3F4F6;  
    padding-bottom: 16px;
  }
  .detail-row:last-child {
    border-bottom: none;
  }
  
  .detail-label {
    color: #6B7280; 
  }
  .detail-value {
    color: #374151; 
    font-weight: 500;
  }
  
   
  .status-text.successful { color: #16A34A; font-weight: 600; }
  .status-text.pending { color: #D97706; font-weight: 600; }
  .status-text.failed { color: #DC2626; font-weight: 600; }
  .status-text-green { color: #16A34A; font-weight: 600; }  
  
  .modal-footer {
    margin-top: 32px;
  }
  .download-pdf-btn {
    width: auto;
    background: transparent;
    color: #F97316;  
    border: none;
    border-radius: 8px;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
  .download-pdf-btn img {
    width: 20px;
    height: 20px;
  }
  
   
  @media (max-width: 600px) {
    .modal-content {
      padding: 24px;
      max-width: 90%;
    }
    .modal-title h1 {
      font-size: 28px;
    }
  }

  @media (max-width: 480px) {
    .modal-content { padding: 12px; max-width: 98vw; }
    .modal-title h1 { font-size: 18px; }
    .detail-row { font-size: 12px; }
  }`, "",{"version":3,"sources":["webpack://./src/compoonents/TransactionDetailsModal/TransactionDetailsModal.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;EAC5D,qBAAqB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;;EAEpH;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;;;EAGA,wCAAwC,yBAAyB,EAAE;EACnE,qCAAqC,yBAAyB,EAAE;EAChE,oCAAoC,yBAAyB,EAAE;;EAE/D;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;;;EAGA,0BAA0B,cAAc,EAAE,gBAAgB,EAAE;EAC5D,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;EACzD,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;EACxD,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;;EAEvD;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;EACd;;;EAGA;IACE;MACE,aAAa;MACb,cAAc;IAChB;IACA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,iBAAiB,aAAa,EAAE,eAAe,EAAE;IACjD,kBAAkB,eAAe,EAAE;IACnC,cAAc,eAAe,EAAE;EACjC","sourcesContent":["/* src/components/TransactionDetailsModal/TransactionDetailsModal.css */\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(34, 42, 63, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    animation: fadeIn 0.3s ease;\n  }\n  \n  .modal-content {\n    background: #FFFFFF;\n    border-radius: 16px;\n    padding: 32px;\n    width: 100%;\n    max-width: 550px;\n    position: relative;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    animation: slideUp 0.4s ease;\n    font-family: 'Inter', sans-serif;\n  }\n  \n  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n  @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }\n  \n  .modal-close-btn {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background: #EBF4FF;  \n    border: none;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 36px;\n    text-align: center;\n    color: #0047AB;  \n    cursor: pointer;\n    transition: transform 0.2s;\n  }\n  .modal-close-btn:hover {\n    transform: scale(1.1);\n  }\n  \n  .modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding-bottom: 24px;\n    margin-bottom: 24px;\n  }\n  .modal-title p {\n    font-size: 14px;\n    font-weight: 500;\n    color: #0047AB; \n    margin: 0 0 4px;\n    text-transform: uppercase;\n  }\n  .modal-title h1 {\n    font-size: 36px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0;\n    line-height: 1.2;\n  }\n  .modal-title span {\n    font-size: 14px;\n    color: #9CA3AF;  \n  }\n  .modal-status-icon-wrapper {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;  \n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .modal-status-icon-wrapper img {\n    width: 24px;\n    height: 24px;\n  }\n  \n  \n  .modal-status-icon-wrapper.successful { background-color: #DEF7EC; }\n  .modal-status-icon-wrapper.pending { background-color: #FEF3C7; }\n  .modal-status-icon-wrapper.failed { background-color: #FEE2E2; }\n  \n  .modal-details {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;  \n  }\n  \n  .detail-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 16px;\n    border-bottom: 1px solid #F3F4F6;  \n    padding-bottom: 16px;\n  }\n  .detail-row:last-child {\n    border-bottom: none;\n  }\n  \n  .detail-label {\n    color: #6B7280; \n  }\n  .detail-value {\n    color: #374151; \n    font-weight: 500;\n  }\n  \n   \n  .status-text.successful { color: #16A34A; font-weight: 600; }\n  .status-text.pending { color: #D97706; font-weight: 600; }\n  .status-text.failed { color: #DC2626; font-weight: 600; }\n  .status-text-green { color: #16A34A; font-weight: 600; }  \n  \n  .modal-footer {\n    margin-top: 32px;\n  }\n  .download-pdf-btn {\n    width: auto;\n    background: transparent;\n    color: #F97316;  \n    border: none;\n    border-radius: 8px;\n    padding: 0;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n  .download-pdf-btn img {\n    width: 20px;\n    height: 20px;\n  }\n  \n   \n  @media (max-width: 600px) {\n    .modal-content {\n      padding: 24px;\n      max-width: 90%;\n    }\n    .modal-title h1 {\n      font-size: 28px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .modal-content { padding: 12px; max-width: 98vw; }\n    .modal-title h1 { font-size: 18px; }\n    .detail-row { font-size: 12px; }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
